import LogPeriodAnalyzeReducer from 'store/log/period-analyze/reducers';

export default LogPeriodAnalyzeReducer;
